<template>
    <el-container class="fst-Llms">
        <el-aside>
            <LlmsList ref="list" :active="active" @onClick="handleOnClickItem" @onAdd="setActive()" @afterRemove="setActive()" />
        </el-aside>
        <el-main>
            <LlmsEditor ref="editor" v-model="active" @afterSave="handleAfterSave"/>
        </el-main>
    </el-container>
</template>

<script>
    import LlmsList from './LlmsList.vue';
    import LlmsEditor from './LlmsEditor.vue';

    export default {
        name: "Llms",
        components: {LlmsList, LlmsEditor},
        data() {
            return {
                active: {}
            }
        },
        methods: {
            setActive(item) {
                this.active = item || {};
                this.$nextTick(() => {
                    this.$refs.editor.refresh();
                })
            },
            handleOnClickItem(item) {
                this.setActive(item);
            },
            handleAfterSave(item) {
                this.$refs.list.load().then(() => {
                    this.active = item || {};
                });
            }
        }
    }
</script>

<style lang="scss">
    @use "@/assets/imports.scss" as *;

    .fst-Llms {
        height: calc(100% - 20px);
        padding: 20px;
        background: $iq-color-white;
        border: 1px solid $iq-border-color-light;
        border-radius: 5px;
        > .el-aside {
            width: 400px !important;
            border-right: 1px solid $iq-border-color-light;
            overflow: hidden;
            display: flex;
            flex-direction: column;
        }
        > .el-main {
            padding: 0 0 0 20px;
            > * {
                max-width: 1000px;
            }
        }
    }
</style>
